import { Controller } from 'stimulus';
import { handleError } from '../../lib/error';
import { sateiDbCreatePost, transactionIdUrl } from '../../lib/satei_db';

export default class extends Controller {
  static targets = ['sateiNo', 'dealingId', 'offerComment'];

  static values = {
    name: String,
    email: String,
    customer: String,
  };

  async create(event) {
    event.preventDefault();
    try {
      const api_res = await sateiDbCreatePost({
        name: this.nameValue,
        email: this.emailValue,
        campaign_rate: 20,
        memo: this.offerCommentTarget.value,
        customer: this.customerValue,
      });

      if (api_res) {
        const satei_no = api_res.code;
        const dealing_id = api_res.id;
        this.sateiNoTarget.value = satei_no;
        this.dealingIdTarget.value = dealing_id;
        window.open(transactionIdUrl(dealing_id), '_blank');
        this.element.submit();
      }
    } catch (error) {
      handleError(error);
    }
  }
}
